import { render, staticRenderFns } from "./BottomDashboardNav.vue?vue&type=template&id=9ece79e0&"
import script from "./BottomDashboardNav.vue?vue&type=script&lang=js&"
export * from "./BottomDashboardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports